<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'>数据分析</i></el-breadcrumb-item>
                <el-breadcrumb-item>报表看板</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            
            <el-container  style="border: 1px solid #eee">
                <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
                    <el-select @change='handleProjectSelectChange' style='margin-bottom: 1rem;' clearable size='medium' v-model='queryParams.projectAppId' filterable placeholder='请选择'>
                        <el-option
                            v-for='item in projectInfoList'
                            :key='item.appId'
                            :label='item.cnName'
                            :value='item.appId'>
                        </el-option>
                    </el-select>
                    <el-menu @select='handleMenuSelect'>
                        <el-menu-item-group>
                            <el-menu-item index="summary">概况</el-menu-item>
                        </el-menu-item-group>
                        
                        <el-submenu index="1-2">
                            <template slot="title">用户分析</template>
                            <el-menu-item index="activeUser">活跃用户</el-menu-item>
                            <el-menu-item index="retentionUser">留存用户</el-menu-item>
                            <el-menu-item index="newUser">新增用户</el-menu-item>
                        </el-submenu>
                        
                        <el-menu-item index='eventSummary'>报表管理</el-menu-item>
                    </el-menu>
                </el-aside>
                <el-main>
                    <router-view/>
                </el-main>
            </el-container>
        </div>
    </div>
</template>

<script>

import { pageUtil } from '@/utils/pageUtil';
import { message } from '@/utils/message';
import { trackDataApi } from '@api/Track/trackData';
import { trackEventApi } from '@api/Track/trackEvent';
import { projectInfoApi } from '@api/ProjectInfo';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import bus from '@/components/common/bus';

export default {
    name: 'User',
    components: {
        VueJsonPretty,
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                projectAppId: undefined,
                eventId: undefined,
                eventName: undefined
            },
            
            trackDataList: [],
            trackEventList: [],
            currentTrackData: {},
            eventMap: new Map,
            mapTrackerNum: 1,
            projectInfoList: []
        };
    },
    computed: {
        computeEventName() {
            return (data) => {
                let event = this.eventMap.get(parseInt(data.eventId));
                if (!event) {
                    return '未知';
                } else {
                    return event.eventName;
                }
            };
        },
        computeUserAccount() {
            return (data) => {
                // let user = this.adminUserMap.get(data.createUserId)
                // if (!user) {
                //     return '未知'
                // }else {
                //     return user.nickName
                // }
            };
        }
    },
    created() {
        this.getList();
        this.initData();
        // 监听eventBus
        bus.$on('queriedTrackProjectAppId', t => {
            this.queryParams.projectAppId = t
            this.queryTrackEvent(t)
        })
        bus.$on('queriedTrackEventId', t => {
            this.queryParams.eventId = t
        })
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
            this.eventMap = new Map;
            this.trackEventList = [];
            this.projectInfoList = [];
            
            projectInfoApi.query({ pageSize: 10000 }).then(result => {
                if (result.code === 200) {
                    this.projectInfoList = result.data.result;
                }
            });
        },
        getList() {
            this.loading = true;
            trackDataApi.query(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.trackDataList = result.data.result;
                    
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        resetQueryPage() {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '分配分组';
            this.updateStatus = false;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentDataInfo = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件信息';
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let obj = this;
            this.$modal.confirm('是否确认删除"' + row.eventName + '"的数据项？').then(function() {
                return;
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    message.success(result.message);
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
        
        },
        async handleProjectSelectChange(projectAppId) {
            if (!projectAppId) {
                message.error('请选择项目!')
            }
            // 根据appId查询事件
            trackEventApi.queryTrackEvent({projectAppId: projectAppId, pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                    
                    if (this.trackEventList.length === 0) {
                        message.error('当前项目无任何埋点事件!')
                    }else {
                        if (this.queryParams.projectAppId) {
                            bus.$emit('selectedTrackProjectAppId', this.queryParams.projectAppId)
                        }
                    }
                }
            })
        },
        async queryTrackEvent(projectAppId) {
            if (!projectAppId) {
                return
            }
            // 根据appId查询事件
            trackEventApi.queryTrackEvent({projectAppId: projectAppId, pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result;
                    result.data.result.forEach(t => {
                        this.eventMap.set(parseInt(t.id), t);
                        this.mapTrackerNum = this.mapTrackerNum + 1;
                    });
                }
            })
        },
        handleMenuSelect(index, indexPath) {
            if (!this.queryParams.projectAppId || this.queryParams.projectAppId.indexOf('undefined') === 0) {
                message.error('请选择项目!')
                return
            }
            if (index.startsWith("eventMenu")) {
                let indexArr = index.split("-")
                let eventId = indexArr[1]
                this.queryParams.eventId = eventId
                bus.$emit('trackEventIdChange', {
                    projectAppId: this.queryParams.projectAppId,
                    eventId: eventId
                })
                this.$router.push(`/trackAnalyse/eventAnalyse/${this.queryParams.projectAppId}/${eventId}`)
            }else {
                this.$router.push(`/trackAnalyse/${index}/${this.queryParams.projectAppId}`)
            }
        }
    }
};
</script>
